import { jsx as _jsx } from "react/jsx-runtime";
import { GlobalStyles } from '@mui/material';
const PortalGlobalStyles = () => (_jsx(GlobalStyles, { styles: (theme) => ({
        // html: { scrollBehavior: 'instant' },
        '*': {
            boxSizing: 'border-box',
            margin: 0,
            padding: 0,
        },
        html: {
            webkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            height: '100%',
            width: '100%',
        },
        body: {
            fontFamily: theme.typography.fontFamily,
            backgroundColor: theme.portal.site.background.color,
            color: theme.portal.global.font.color,
            height: '100%',
            width: '100%',
        },
        a: {
            textDecoration: 'none',
        },
        '#root': {
            height: '100%',
            width: '100%',
        },
        '.fullHeight': {
            height: '100%',
        },
    }) }));
export default PortalGlobalStyles;
//# sourceMappingURL=PortalGlobalStyles.js.map